var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98611 2.19332L11.9147 5.88203L16.2193 6.47346C16.3585 6.4884 16.4933 6.53098 16.6158 6.59871C16.7384 6.66644 16.8461 6.75796 16.9328 6.86789C17.0195 6.97782 17.0834 7.10396 17.1207 7.2389C17.158 7.37385 17.168 7.51489 17.1501 7.65374C17.1139 7.88234 17.001 8.09182 16.83 8.24774L13.716 11.12L14.4514 15.1739C14.4728 15.312 14.4664 15.4531 14.4325 15.5887C14.3986 15.7244 14.338 15.8519 14.2542 15.9638C14.1703 16.0756 14.065 16.1696 13.9443 16.2402C13.8236 16.3108 13.69 16.3565 13.5514 16.3747C13.3139 16.4133 13.0704 16.3769 12.8545 16.2706L9.00126 14.3549L5.14411 16.2693C4.88753 16.3989 4.59125 16.426 4.31544 16.345C4.03962 16.264 3.80496 16.0812 3.65911 15.8335C3.54636 15.6328 3.50725 15.399 3.54854 15.1726L4.2904 11.1187L1.17254 8.24646C1.0702 8.15366 0.988167 8.0407 0.931591 7.91467C0.875016 7.78863 0.845125 7.65226 0.843796 7.51412C0.842468 7.37598 0.869732 7.23906 0.923873 7.11197C0.978015 6.98487 1.05786 6.87035 1.1584 6.7756C1.33049 6.61035 1.55067 6.50409 1.78711 6.47217L6.09168 5.88074L8.02026 2.19203C8.15813 1.94207 8.38559 1.75363 8.65684 1.66464C8.92808 1.57566 9.22296 1.59274 9.48211 1.71246C9.69928 1.81154 9.87712 1.98033 9.9874 2.19203",
    fill: "url(#paint0_linear_6253_33639)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6253_33639",
    x1: 9.00126,
    y1: 1.6084,
    x2: 9.00126,
    y2: 16.3908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE26E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA43"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFull);
export default __webpack_public_path__ + "static/media/star-full.464dc7d128fa6a76ae755bc819c2c2f6.svg";
export { ForwardRef as ReactComponent };